<div>
  <a *ngIf="(mdRepresentation.representationType==='browse_link')"
     target="_blank" class="dont-break-out"
     [routerLink]="['/browse/', mdRepresentation.browseDefinition.id]"
     [queryParams]="getQueryParams()">
    {{mdRepresentation.getValue()}}
  </a>
  <b>(new browse link page)</b>
</div>
